import { PropsWithChildren, FC, useState } from 'react'

import Box from '~/core/Box'

import { ACTION_TYPES } from './constants'
import AutoExceptionActionButton from './AutoExceptionActionButtons'
import AutoExceptionModal from './AutoExceptionModal'
import { MutationOperation } from './logic'
import styles from './styles.css'

type AutoExceptionButtonType = {
    jobId: number
    pauseException: boolean | undefined | null
}
const AutoExceptionButton: FC<
    PropsWithChildren<AutoExceptionButtonType>
> = props => {
    const { jobId, pauseException } = props

    const [pauseExceptionCreation, setPauseExceptionCreation] = useState<
        boolean | undefined | null
    >(pauseException)

    const [actionType, setActionType] = useState('')
    const useMutationHandler = MutationOperation()
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false)

    const showModal = () => {
        setIsModalVisible(true)
    }
    const handleCancelResumeModal = () => {
        setIsModalVisible(false)
    }

    const handlAutoExceptionStatus = async (status: boolean, id: number) => {
        const result = await useMutationHandler.updateJobException({
            jobId: id,
            pauseException: status,
        })

        if (result) {
            setPauseExceptionCreation(status)
        }
    }

    const handleOk = () => {
        if (actionType === ACTION_TYPES.PAUSE) {
            handlAutoExceptionStatus(true, jobId)
        }
        if (actionType === ACTION_TYPES.RESUME) {
            handlAutoExceptionStatus(false, jobId)
        }
        setIsModalVisible(false)
    }

    const handleButtonAction = (actionName: string) => {
        if (actionName === ACTION_TYPES.PAUSE) {
            showModal()
            setActionType(ACTION_TYPES.PAUSE)
        } else {
            showModal()
            setActionType(ACTION_TYPES.RESUME)
        }
    }

    return (
        <>
            <AutoExceptionModal
                visible={isModalVisible}
                handleCancel={handleCancelResumeModal}
                actionType={
                    pauseExceptionCreation
                        ? ACTION_TYPES.RESUME
                        : ACTION_TYPES.PAUSE
                }
                handleDone={handleOk}
            />
            <Box>
                {pauseException ? (
                    <AutoExceptionActionButton
                        name="resume-exception"
                        dataTestTarget="resume-button"
                        actionType={ACTION_TYPES.RESUME}
                        className={styles.headerBtn}
                        onClick={handleButtonAction}
                    />
                ) : (
                    <AutoExceptionActionButton
                        name="pause-exception"
                        dataTestTarget="pause-button"
                        actionType={ACTION_TYPES.PAUSE}
                        className={styles.headerBtn}
                        onClick={handleButtonAction}
                    />
                )}
            </Box>
        </>
    )
}

export default AutoExceptionButton
